
//local imports
import { ToastMessage } from "@app/components";
import {
  ServicesMatrixExportQueuedNotification,
  ServicesMatrixExportReadyNotification,
  ServicesMatrixExportStartedNotification,
} from "@app/macd-common";



import { Messenger } from "@app/shared";
import { AppStateService } from "@app/core";


export class ServicesMatrixExportStateHandler {

  public initialize(appStateService: AppStateService, messager: Messenger) {

    messager.subscribe(appStateService, ServicesMatrixExportReadyNotification, (notification: ServicesMatrixExportReadyNotification) => {
      console.log("Initializing ServicesMatrixExportStateHandler", notification);
      // Log and notify when export is ready
      let message = notification.getMessage();
      messager.send(ToastMessage.create(message.message, message.level));
      appStateService.addNotification(message);
    });

    messager.subscribe(appStateService, ServicesMatrixExportStartedNotification, (notification: ServicesMatrixExportStartedNotification) => {
      // Log and notify when export is started
       let message = notification.getMessage();
      messager.send(ToastMessage.create(message.message, message.level));
       appStateService.addNotification(message);
    });

    messager.subscribe(appStateService, ServicesMatrixExportQueuedNotification, (notification: ServicesMatrixExportQueuedNotification) => {
      // Log and notify when export is queued
       let message = notification.getMessage();
      messager.send(ToastMessage.create(message.message, message.level));
      appStateService.addNotification(message);
    });
  }
}